<template lang="pug">
  div(class="footer-block")
    div(class="share")
      a(:href="facebookShareUrl", target="_blank", class="shareItem")
        img(src="~images/Event/OnlineSalon/About/facebook.png")
      a(:href="twitterShareUrl", target="_blank", class="shareItem")
        img(src="~images/Event/OnlineSalon/About/twitter.png")
    div(class="copyright") Copyright © 2020 KAYAC Living, Inc. All rights reserved.
</template>
<script>
  export default {
    data() {
      const ogpTitle = '移住したい人1万人突破！ | 地域への移住と関係人口のマッチング SMOUT（スマウト）';
      return {
        facebookShareUrl: 'https://www.facebook.com/dialog/share?app_id=2016611608613190&display=popup&href=https://smout.jp/event/infographics',
        twitterShareUrl: `https://twitter.com/intent/tweet?text=${encodeURI(ogpTitle)}&url=${encodeURIComponent('https://smout.jp/event/infographics')}&hashtags=インフォグラフィック,SMOUT&via=smoutjp`,
      };
    },
  };
</script>
<style lang="scss" scoped>
  .footer-block {
    background-color: #fff;
  }
  .share {
    padding: 20px;
    text-align: center;
  }
  .shareItem {
    display: inline-block;
    width: 40px;
    height: 40px;
    margin-left: 10px;
    margin-right: 10px;
    @include mq('sm') {
      width: 50px;
      height: 50px;
    }
  }
  .copyright {
    font-size: 1.2rem;
    text-align: center;
    padding-bottom: 1em;
  }
</style>
